import { render, staticRenderFns } from "./ProjectValuationScoreStructure.vue?vue&type=template&id=5980145c&scoped=true&"
import script from "./ProjectValuationScoreStructure.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationScoreStructure.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationScoreStructure.vue?vue&type=style&index=0&id=5980145c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980145c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
